export default __webpack_public_path__ + "static/media/buildings-green.d86a6822.svg";